// Import utilities for the api.
import { g, l, Cookie } from './';
import { clearOmCookiesStorage, storageAvailable, trigger } from './Helpers';

/**
 * The main api class that constructs all other components.
 *
 * @since 5.0.0
 */
export default class Sessions {
	/**
	 * "Class" constructor in ES6.
	 *
	 * @since 5.0.0
	 *
	 * @param {Object} defaults the default data set for this instance of Api.js
	 */
	constructor(defaults) {
		// Set some default variables for the class.
		this.defaults = defaults;

		if (window[g.GLOBAL_OM].sessions) {
			return;
		}

		// Initialize!
		this.init();
	}

	/**
	 * A default method to initialize the class.
	 *
	 * @since 5.0.0
	 *
	 * @returns {void}
	 */
	init() {
		trigger(document, 'Sessions.init', {
			Sessions: this,
		});

		window[g.GLOBAL_OM].sessions = true;

		try {
			// Make sure session storage is available.
			if (!storageAvailable('sessionStorage')) {
				// Warn that we are using cookies instead.
				throw true;
			}
			const storage = window.sessionStorage;

			// Ok, if someone wants to clear sessions, we will do that now.
			if (clearOmCookiesStorage()) {
				storage.removeItem('omSessionStart');
				storage.removeItem('omSessionPageviews');
				storage.removeItem('omScrollHeight');
			}

			// Create or set session start time.
			let sessionTime = storage.getItem('omSessionStart');
			if (null === sessionTime) {
				storage.setItem('omSessionStart', this.defaults.pageStart);
			}

			// Create or increment session pageviews.
			let sessionPageviews = storage.getItem('omSessionPageviews') || 0;
			storage.setItem('omSessionPageviews', ++sessionPageviews);

			// Try and cache the page height for the session
			// https://github.com/awesomemotive/optinmonster-api-js/issues/681
			let scrollHeight = document.documentElement['scrollHeight'] || document.body['scrollHeight'];
			storage.setItem('omScrollHeight', scrollHeight);
		} catch (er) {
			l.debug('Sessions are not supported on this browser. Attempting to use cookies instead.');

			// Since we don't support session storage, let's revert to cookies instead.
			this.cookies();
		}
	}

	/**
	 * Static method to get Session data.
	 *
	 * @since 5.0.0
	 *
	 * @param   {string} item The session item to lookup.
	 * @returns {string}      The value returned based on the item name.
	 */
	static get = (item) => {
		return 'object' === typeof window.sessionStorage ? window.sessionStorage.getItem(item) : Cookie.get(item);
	};

	/**
	 * The backup plan is to use cookies instead of session storage if its not available.
	 *
	 * @since 5.0.0
	 *
	 * @returns {void}
	 */
	cookies = () => {
		// Ok, if someone wants to clear cookies, we will do that now.
		if (clearOmCookiesStorage()) {
			Cookie.delete('omSessionStart');
			Cookie.delete('omSessionPageviews');
		}

		// Create or set session start time.
		let sessionTime = Cookie.get('omSessionStart');
		if (!sessionTime) {
			Cookie.sessionCreate('omSessionStart', this.defaults.pageStart);
		}

		// Create or increment session pageviews.
		let sessionPageviews = Cookie.get('omSessionPageviews') || 0;
		Cookie.sessionCreate('omSessionPageviews', ++sessionPageviews);
	};
}
